import Vue from 'vue'
import validate from 'mixins/validate'

Vue.component('account-login-form', {
  data () {
    return {}
  },
  computed: {
    active () {
      return this.$parent.activeForm === 'login'
    }
  },
  methods: {
    submitForm (e) {
      const isValid = this.validateAndDisplayErrors(e)

      if (!isValid) {
        e.preventDefault()
      }
    }
  },
  mixins: [validate]
})
